(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8104],{

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 42910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _3_the_process_TheProcess; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(12755);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
// EXTERNAL MODULE: ./data/StaticList.ts + 69 modules
var StaticList = __webpack_require__(47027);
// EXTERNAL MODULE: ./utils/ImageExport.ts + 6 modules
var ImageExport = __webpack_require__(80645);
// EXTERNAL MODULE: ./utils/Constants.ts
var Constants = __webpack_require__(40953);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-lottie/dist/index.js
var dist = __webpack_require__(79464);
;// CONCATENATED MODULE: ./components/AppAnimation.tsx



function AppAnimation(param) {
    let { data  } = param;
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: data
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            options: defaultOptions,
            height: "100%",
            width: "100%"
        })
    });
}
/* harmony default export */ var components_AppAnimation = (AppAnimation);

;// CONCATENATED MODULE: ./components/home/3-the-process/TheProcess.tsx











const TheProcess = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            sx: {
                alignItems: "center",
                minHeight: {
                    xs: "70vh",
                    md: "100vh"
                },
                justifyContent: "center",
                padding: {
                    xs: "50px 0",
                    md: "3%"
                }
            },
            style: {
                width: "100vw",
                backgroundColor: "#F4F7FF",
                position: "relative"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                sx: {
                    width: "90%",
                    justifyContent: "space-around",
                    alignItems: "center",
                    flexDirection: "column",
                    maxWidth: "1440px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            textAlign: "center",
                            fontWeight: "700",
                            fontSize: {
                                xs: "24px",
                                md: "40px"
                            },
                            marginBottom: {
                                xs: "20px",
                                md: "0"
                            }
                        },
                        children: "Start earning with 3 easy steps"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        sx: {
                            display: {
                                xs: "none",
                                md: "flex"
                            },
                            width: "100%",
                            height: {
                                xs: "400px",
                                md: "500px",
                                lg: "500px"
                            },
                            boxSizing: "border-box",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "nowrap"
                        },
                        children: StaticList/* THE_PROCESS_LIST.map */.iJ.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                sx: {
                                    height: "80%",
                                    width: {
                                        xs: "400px",
                                        md: "30%",
                                        lg: "30%"
                                    },
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: "1px",
                                    boxSizing: "border-box",
                                    textAlign: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        sx: {
                                            height: {
                                                xs: "180px",
                                                md: "216px"
                                            },
                                            width: {
                                                xs: "180px",
                                                md: "216px"
                                            },
                                            borderRadius: "50%",
                                            margin: "auto",
                                            zIndex: "1"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AppAnimation, {
                                            data: item.img
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        style: {
                                            height: "80%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                sx: {
                                                    height: "40px",
                                                    width: "40px",
                                                    margin: {
                                                        xs: "10px auto",
                                                        md: "20px auto"
                                                    },
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "50%",
                                                    fontSize: "28px",
                                                    backgroundColor: "#27BF35",
                                                    color: "white"
                                                },
                                                children: item.id
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    padding: "0px 2px",
                                                    fontWeight: "bold",
                                                    fontSize: {
                                                        xs: "20px",
                                                        md: "24px"
                                                    }
                                                },
                                                children: item.title
                                            })
                                        ]
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            margin: "auto",
                            width: "320px",
                            paddingTop: "4px",
                            display: {
                                xs: "block",
                                md: "none"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
                            autoPlay: true,
                            interval: 4000,
                            infiniteLoop: true,
                            showStatus: false,
                            showThumbs: false,
                            swipeable: false,
                            children: StaticList/* THE_PROCESS_LIST.map */.iJ.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        height: {
                                            xs: "350px",
                                            md: "400px"
                                        },
                                        width: {
                                            xs: "300px",
                                            md: "30%",
                                            lg: "30%"
                                        },
                                        alignItems: "center",
                                        justifyContent: "center",
                                        zIndex: "1px",
                                        boxSizing: "border-box",
                                        textAlign: "center",
                                        margin: "20px auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            style: {
                                                height: "180px",
                                                width: "180px",
                                                borderRadius: "50%",
                                                margin: "auto",
                                                zIndex: "1"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AppAnimation, {
                                                data: item.img
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            style: {
                                                height: "60%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    style: {
                                                        height: "40px",
                                                        width: "40px",
                                                        margin: "20px auto",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        borderRadius: "50%",
                                                        fontSize: "28px",
                                                        backgroundColor: "#27BF35",
                                                        color: "white",
                                                        wordWrap: "break-word"
                                                    },
                                                    children: item.id
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    sx: {
                                                        padding: "0px 2px",
                                                        fontWeight: "bold",
                                                        wordWrap: "break-word",
                                                        fontSize: {
                                                            xs: "22px",
                                                            md: "24px"
                                                        }
                                                    },
                                                    children: item.title
                                                })
                                            ]
                                        })
                                    ]
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                height: {
                                    xs: "45px",
                                    md: "64px"
                                },
                                width: {
                                    xs: "140px",
                                    md: "216px"
                                },
                                marginRight: "25px",
                                cursor: "pointer",
                                display: {
                                    xs: "none",
                                    md: "block"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: Constants/* appLink */.ze,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: ImageExport/* PLAYSTORE_BLACK */.ZE,
                                    alt: "playStore",
                                    style: {
                                        height: "100%",
                                        width: "100%",
                                        objectFit: "contain"
                                    },
                                    loading: "lazy"
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var _3_the_process_TheProcess = (TheProcess);


/***/ })

}]);